// Slow editorial marquee
export default function Marquee({ items, className = "", speed = 40, dark = false, separator = "/" }) {
  const content = (
    <div className="marquee-track" style={{ animation: `marquee ${speed}s linear infinite` }}>
      {items.concat(items).map((item, i) => (
        <span key={i} className="inline-flex items-center">
          <span className="px-8 font-display text-4xl md:text-6xl uppercase tracking-tighter">
            {item}
          </span>
          <span className={dark ? "text-ez-yellow" : "text-ez-text/30"}>{separator}</span>
        </span>
      ))}
    </div>
  );

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {content}
      <style>{`@keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
    </div>
  );
}
